<template>
  <svg
  v-if='true'
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <path
      d="M16,2c-7.732,0-14,6.268-14,14,0,6.566,4.52,12.075,10.618,13.588v-9.31h-2.887v-4.278h2.887v-1.843c0-4.765,2.156-6.974,6.835-6.974,.887,0,2.417,.174,3.043,.348v3.878c-.33-.035-.904-.052-1.617-.052-2.296,0-3.183,.87-3.183,3.13v1.513h4.573l-.786,4.278h-3.787v9.619c6.932-.837,12.304-6.74,12.304-13.897,0-7.732-6.268-14-14-14Z"
    ></path>
  </svg>
  <svg
    v-else
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0084 19.7812V12.4834H15.5048L15.8793 9.6385H13.0084V7.82243C13.0084 6.99901 13.2405 6.43786 14.4457 6.43786L15.9804 6.43724V3.89263C15.715 3.85881 14.804 3.78125 13.7437 3.78125C11.5296 3.78125 10.0138 5.10682 10.0138 7.54067V9.6385H7.50977V12.4834H10.0138V19.7812H13.0084Z"
      fill="#22282B"
    />
    <mask
      id="mask0_534_618"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="7"
      y="3"
      width="9"
      height="17"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.0084 19.7812V12.4834H15.5048L15.8793 9.6385H13.0084V7.82243C13.0084 6.99901 13.2405 6.43786 14.4457 6.43786L15.9804 6.43724V3.89263C15.715 3.85881 14.804 3.78125 13.7437 3.78125C11.5296 3.78125 10.0138 5.10682 10.0138 7.54067V9.6385H7.50977V12.4834H10.0138V19.7812H13.0084Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_534_618)"></g>
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  width: {
    type: [String, Number],
    default: 40,
  },
  height: {
    type: [String, Number],
    default: 40,
  },
});
</script>

<style lang="scss" scoped></style>
